module.exports = __webpack_public_path__ + "img/d2295304fc6577cfb811222da420ca5e.png";